import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['reloadable', 'ticket', 'detail', 'row']

  connect() {
    setInterval(() => {
      this.reload()
    }, 10000)
  }

  selectTicket(e) {
    let selectedTicket = this.ticketTargets.find(el => {
      return this.getTicketId(el) === this.getTicketId(e.currentTarget)
    })

    // lets highlight the row too
    this.selectedTicketId = this.getTicketId(selectedTicket)
    let selectedRow = this.rowTargets.find(el => {
      return this.getTicketId(el) === this.getTicketId(e.currentTarget)
    })
    this.markAllRowsNotSelected()
    this.markRowSelected(selectedRow)

    this.clearElement(this.detailTarget)
    this.detailTarget.appendChild(selectedTicket.content.cloneNode(true))
  }

  reload() {
    let selector = `#${ this.reloadableTarget.id }`
    let ticketsBefore = this.ticketIds

    fetch(window.location.href)
      .then(resp => resp.text())
      .then(text => {
        const parser = new DOMParser()
        const htmlDocument = parser.parseFromString(text, 'text/html')
        const element = htmlDocument.documentElement.querySelector(selector)

        this.reloadableTarget.innerHTML = element.innerHTML

        let selectedRow = this.rowTargets.find(el => {
          return this.getTicketId(el) === this.selectedTicketId
        })
        this.markRowSelected(selectedRow)

        if (this.shouldNotify(ticketsBefore, this.ticketIds)) {
          this.notify()
        }
      })
  }

  clearElement(el) {
    while (el.firstChild) {
      el.removeChild(el.firstChild)
    }
  }

  get restaurantId() {
    return this.data.get('restaurantId')
  }

  getTicketId(el) {
    return el.getAttribute('data-ticket-id')
  }

  get ticketIds() {
    return this.ticketTargets.map(el => {
      return this.getTicketId(el)
    })
  }

  markAllRowsNotSelected() {
    this.rowTargets.forEach(el => {
      this.markRowNotSelected(el)
    })
  }

  markRowSelected(e) {
    if (!e) return;

    e.classList.toggle('selected', true)
  }

  markRowNotSelected(e) {
    if (!e) return;

    e.classList.toggle('selected', false)
  }

  shouldNotify(ticketsBefore, ticketsAfter) {
    return ticketsAfter.some(ticketId => {
      return !ticketsBefore.includes(ticketId)
    })
  }

  notify() {
    let audio = new Audio('/audio/ticket-queue-notify.wav');
    audio.play();
  }
}
